import { getDomainConfig } from '../apis/domain';
import { useQuery } from 'react-query';
import { UIDomainConfig } from '../../../../packages/types/src/domainConfig';
import { data as shardaData } from '../data/sharda';
import { data as sharda9Data } from '../data/sharda9';
import { data as atriaData } from '../data/atria';

import { data as gopalanData } from '../data/gopalan';
import { data as kleitData } from '../data/kleit';
import { data as seaengineeringData } from '../data/seaengineering';
import { data as acpceData } from '../data/acpce';
import { data as anandiceData } from '../data/anandice';
import { data as kitData } from '../data/kit';
import { data as miteData } from '../data/mite';
import { data as mmcoeData } from '../data/mmcoe';
import { data as srinivasData } from '../data/srinivas';
import { data as sritData } from '../data/srit';
import { data as viitData } from '../data/viit';
import { data as jnnceData } from '../data/jnnce';
import { data as kitsgunturData } from '../data/kitsguntur';
import { data as iceasData } from '../data/iceas';
import { data as svceData } from '../data/svce';
import { data as cityengineeringcollegeData } from '../data/cityengineeringcollege';
import { data as pgmcoeData } from '../data/pgmcoe';
import { data as bitjaipurData } from '../data/bitjaipur';
import { data as vjitData } from '../data/vjit';
import { data as pscmrData } from '../data/pscmr';
import { data as sinhgadData } from '../data/sinhgad';
import { data as mescoeData } from '../data/mescoe';
import { data as gmritData } from '../data/gmrit';
import { data as sahyadriData } from '../data/sahyadri';
import { data as dayanandasagarData } from '../data/dayanandasagar';
import { data as ttitData } from '../data/ttit';
import { data as cmritData } from '../data/cmrit';
import { data as gnitsData } from '../data/gnits';
import { data as mitaoeData } from '../data/mitaoe';
import { data as sreedatthaData } from '../data/sreedattha';
import { data as vmrfduData } from '../data/vmrfdu';
import { data as vmrfdu9Data } from '../data/vmrfdu9';
import { data as sarala9Data } from '../data/sarala9';
import { data as saralaData } from '../data/sarala';
import { data as kalasalingamData } from '../data/kalasalingam';
import { data as crescentData } from '../data/crescent';
import { data as iesData } from '../data/ies';
import { data as abhilashiData } from '../data/abhilashi';
import { data as invertisData } from '../data/invertis';
import { data as drmgrData } from '../data/drmgr';

const dataByDomainKey = {
	sharda: shardaData,
	sharda9: sharda9Data,
	atria: atriaData,
	kleit: kleitData,
	gopalan: gopalanData,
	seaengineering: seaengineeringData,
	acpce: acpceData,
	anandice: anandiceData,
	kit: kitData,
	mite: miteData,
	mmcoe: mmcoeData,
	srinivas: srinivasData,
	srit: sritData,
	viit: viitData,
	jnnce: jnnceData,
	kitsguntur: kitsgunturData,
	iceas: iceasData,
	svce: svceData,
	cityengineeringcollege: cityengineeringcollegeData,
	pgmcoe: pgmcoeData,
	bitjaipur: bitjaipurData,
	vjit: vjitData,
	pscmr: pscmrData,
	sinhgad: sinhgadData,
	mescoe: mescoeData,
	gmrit: gmritData,
	sahyadri: sahyadriData,
	dayanandasagar: dayanandasagarData,
	ttit: ttitData,
	cmrit: cmritData,
	gnits: gnitsData,
	mitaoe: mitaoeData,
	sreedattha: sreedatthaData,
	vmrfdu9: vmrfdu9Data,
	sarala9: sarala9Data,
	sarala: saralaData,
	kalasalingam: kalasalingamData,
	crescent: crescentData,
	ies: iesData,
	abhilashi: abhilashiData,
	invertis: invertisData,
	vmrfdu: vmrfduData,
	drmgr: drmgrData,
};

export const useDomainConfig = ({ uiHost }: { uiHost: string }) => {
	const uiHostForDevelopment = process.env.REACT_APP_UI_HOST_FOR_DEVELOPMENT_MODE || '';
	return useQuery({
		queryKey: ['domainConfig'],
		queryFn: async () =>
			(await getDomainConfig({ uiHost: uiHost.includes('prepleaf.com') ? uiHost : uiHostForDevelopment })).data.domainConfig as UIDomainConfig,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
	});
};

export const useDomainUIConfig = () => {
	// @ts-ignore
	return {
		data: {
			...sharda9Data,
			logo: '',
			UnlockingOpportunities: {
				...sharda9Data.UnlockingOpportunities,
				bannerImage: '',
			},
		},
		//dataByDomainKey[domainName],

		isLoading: false,
		isSuccess: true,
	};
};
